export const CARD_LOAD_SIZE_DESKTOP = 48;
export const CARD_LOAD_SIZE_NON_DESKTOP = 30;
